import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert, Card, CardTitle } from '@reveni-io/reveni-ui'

import NetSalesToMarginCardSkeleton from './NetSalesToMarginCardSkeleton/NetSalesToMarginCardSkeleton'
import NetSalesToMarginContent from './NetSalesToMarginContent/NetSalesToMarginContent'

const NetSalesToMarginCard = ({ earnings, loading, error }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (loading) return <NetSalesToMarginCardSkeleton />

  if (error) {
    return (
      <Card>
        <CardTitle marginBottom={theme.spacing.sp16}>{t('De ventas netas a margen')}</CardTitle>
        <Alert type="error">{t('No se han podido cargar los datos. Inténtalo de nuevo.')}</Alert>
      </Card>
    )
  }

  return (
    <Card>
      <CardTitle marginBottom={theme.spacing.sp16}>{t('De ventas netas a margen')}</CardTitle>
      <NetSalesToMarginContent earnings={earnings} />
    </Card>
  )
}

export default NetSalesToMarginCard
